import { Typography } from "@material-ui/core";
import { modalStressTextColor } from "../../lib/Color";

type Props = {
    status: "HP" | "PHY" | "INT" | "AGI";
    hero?: number;
    leftExtension?: number;
    rightExtension?: number;
}
const MemberStatusText = ({ status, hero = 0, leftExtension = 0, rightExtension = 0 }: Props) => {
    const total = Number(hero) + Number(leftExtension) + Number(rightExtension)
    return (
        <Typography style={{ color: modalStressTextColor, margin: "10" }}>{status}:{total}
            {leftExtension != 0 && " L:" + leftExtension}
            {rightExtension != 0 && " R:" + rightExtension}
        </Typography>
    );
}

export default MemberStatusText;